import {
  AccessTime,
  AccountCircle,
  Business,
  Email,
  Phone,
  Home,
  Person,
} from "@mui/icons-material";
import { Box, Grid } from "@mui/material";
import InformationTile from "components/Shared/InformationTile";
import InfoGridSkeleton from "components/Shared/Skeleton/InfoGridSkeleton";
import { useVendorDetailContext } from "contexts/Contacts/VendorContext";
import moment from "moment";

const formatDate = (dateString) => moment(dateString).format("MMMM Do, YYYY");

const VendorBasicDetails = () => {
  const { vendorDetail, loadingDetail } = useVendorDetailContext();
  

  return !loadingDetail ? (
    <Box padding={3}>
      <Grid container spacing={4}>
        <Grid item md={12}>
          <Box display="flex" flexDirection="column" gap={3}>
            <Grid container spacing={2}>
              <Grid item md={4}>
                <InformationTile
                  icon={() => <AccountCircle color="primary" />}
                  title="Name"
                  subtitle={vendorDetail?.name}
                />
              </Grid>

              <Grid item md={4}>
                <InformationTile
                  icon={() => <Business color="primary" />}
                  title="Type"
                  subtitle={vendorDetail?.type}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  title="Email"
                  icon={() => <Email color="primary" />}
                  subtitle={vendorDetail?.email}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  title="Phone"
                  icon={() => <Phone color="primary" />}
                  subtitle={vendorDetail?.phone}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  title="Address"
                  icon={() => <Home color="primary" />}
                  subtitle={vendorDetail?.address}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  title="Controlling User"
                  icon={() => <Person color="primary" />}
                  subtitle={vendorDetail?.controllingUser?.name}
                />
              </Grid>
              {vendorDetail?.userRef && (
                <Grid item md={4}>
                  <InformationTile
                    title="Connected User"
                    icon={() => <Person color="primary" />}
                    subtitle={vendorDetail?.userRef?.name}
                  />
                </Grid>
              )}

              <Grid item md={4}>
                <InformationTile
                  title="Created At"
                  icon={() => <AccessTime color="primary" />}
                  subtitle={formatDate(vendorDetail?.createdAt)}
                />
              </Grid>
              <Grid item md={4}>
                <InformationTile
                  title="Updated At"
                  icon={() => <AccessTime color="primary" />}
                  subtitle={formatDate(vendorDetail?.updatedAt)}
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  ) : (
    <InfoGridSkeleton />
  );
};

export default VendorBasicDetails;
